module.exports = __webpack_public_path__ + "static/Dominion-ba29d0f3649eabebcd7fea26ebb5b761.png";